import { memo, useState, useEffect, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { isNil } from 'lodash';
// Import Services
import { ReportHttpService } from 'services/http';
// Import Hooks
import useRequest from 'hooks/UseRequest';
import useCancelableRequests from 'hooks/UseCancelableRequests';
// Import UI Components
import { BusyLoader, Title } from '@geneui/components';
// Import Components
import DynamicSegmentInfo from 'components/DynamicSegment/DynamicSegmentInfo';
import ColumnKPIs from './ColumnKPIs';
// Import Types
import { SegmentFilterUIModel } from 'types';
// Import Constants
import { l, ReportTypesLabels } from 'constants/common';
//Import SCSS
import 'assets/scss/reportInfoModal.scss';
interface ColumnKPIsAndFiltersInfoProps {
    reportType: number;
    reportInfo: Nullable<AnyObject>;
    segmentFiltersData: Nullable<Record<string, SegmentFilterUIModel>>;
}

const ColumnKPIsAndFiltersInfo: FC<ColumnKPIsAndFiltersInfoProps> = ({
    reportType,
    reportInfo,
    segmentFiltersData,
}) => {
    const { t } = useTranslation();
    const { doGetRequest } = useRequest();
    const [columns, setColumns] = useState(null);

    const { getReportConfigurationColumns } = useCancelableRequests({
        getReportConfigurationColumns: ReportHttpService.getReportConfigurationColumns,
    });

    const init = () => {
        doGetRequest(getReportConfigurationColumns.request, {
            successCallback: (Data) =>
                setColumns(
                    Data.reduce((acc, item) => {
                        acc = { ...acc, [item.Id]: item };
                        return acc;
                    }, {}),
                ),
        });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(init, []);

    return (
        <>
            <div className="crm-object-modal-bottom segment-modal-head-bottom">
                <Title text={t(l.ColumnKPIs)} withLine />
                <BusyLoader isBusy={isNil(columns)} type="spinner" spinnerSize="medium">
                    {!isNil(columns) && (
                        <ColumnKPIs
                            kpis={reportInfo?.QueryConfiguration.Columns.map((item) =>
                                isNil(columns[item.Id]) ? item : columns[item.Id],
                            )}
                        />
                    )}
                </BusyLoader>
            </div>
            {reportType === ReportTypesLabels.Report && (
                <div className="crm-object-modal-bottom">
                    <Title text={t(l.SegmentInfo)} withLine />
                    <div className="crm-object-modal-b-content c-s-b-content">
                        <DynamicSegmentInfo segmentFiltersData={segmentFiltersData} />
                    </div>
                </div>
            )}
        </>
    );
};

export default memo(ColumnKPIsAndFiltersInfo);
